export default __webpack_public_path__ + "img/1fd70effae8d24acc37b3774bf295bc6.png";